module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-angry.59f7fc26.png";